export const MAX_CONCURRENT_ANALYSES = 10;
export const FIREBASE_FUNCTION_REGION = "europe-west1";
